var _path, _g, _path2, _g2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon / Upload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6467:40835",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 9,
    width: 20,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00049 9.29395H22.0001V23.0379H2.00049V9.29395Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6467:40835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5655 23.0379H6.43549C3.99049 23.0379 2.00049 21.0489 2.00049 18.6029V13.7279C2.00049 11.2829 3.99049 9.29395 6.43549 9.29395H7.36849C7.78249 9.29395 8.11849 9.62995 8.11849 10.0439C8.11849 10.4579 7.78249 10.7939 7.36849 10.7939H6.43549C4.81649 10.7939 3.50049 12.1099 3.50049 13.7279V18.6029C3.50049 20.2219 4.81649 21.5379 6.43549 21.5379H17.5655C19.1835 21.5379 20.5005 20.2219 20.5005 18.6029V13.7189C20.5005 12.1059 19.1885 10.7939 17.5765 10.7939H16.6335C16.2195 10.7939 15.8835 10.4579 15.8835 10.0439C15.8835 9.62995 16.2195 9.29395 16.6335 9.29395H17.5765C20.0155 9.29395 22.0005 11.2789 22.0005 13.7189V18.6029C22.0005 21.0489 20.0105 23.0379 17.5655 23.0379Z",
    fill: "#D83612"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6467:40835",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 2,
    width: 2,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 2.5H12.75V16.0409H11.25V2.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6467:40835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.041C11.586 16.041 11.25 15.705 11.25 15.291V3.25C11.25 2.836 11.586 2.5 12 2.5C12.414 2.5 12.75 2.836 12.75 3.25V15.291C12.75 15.705 12.414 16.041 12 16.041Z",
    fill: "#D83612"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0852 6.92853C8.8942 6.92853 8.7022 6.85553 8.5562 6.70953C8.2632 6.41753 8.2612 5.94353 8.5542 5.64953L11.4692 2.72153C11.7502 2.43853 12.2502 2.43853 12.5312 2.72153L15.4472 5.64953C15.7392 5.94353 15.7382 6.41753 15.4452 6.70953C15.1512 7.00153 14.6772 7.00153 14.3852 6.70753L12.0002 4.31353L9.6162 6.70753C9.4702 6.85553 9.2772 6.92853 9.0852 6.92853Z",
    fill: "#D83612"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b036fd23517e957701aa3af1b41c6540.svg";
export { ForwardRef as ReactComponent };